/**
 * Reads `hasPACKItem` from calculate-document-item / get-product-document-item-by-id
 * responses (PascalCase / camelCase, nested under data / document / order).
 */
export const responseHasPackItem = (payload: unknown): boolean => {
  if (payload == null) {
    return false;
  }

  const isTruthyFlag = (value: unknown): boolean =>
    value === true || value === "true" || value === 1 || value === "1";

  const readFromRecord = (record: Record<string, unknown>): boolean => {
    if (
      isTruthyFlag(record.hasPACKItem) ||
      isTruthyFlag(record.HasPACKItem) ||
      isTruthyFlag(record.hasPackItem) ||
      isTruthyFlag(record.HasPackItem)
    ) {
      return true;
    }

    const nestedKeys = [
      "document",
      "Document",
      "order",
      "Order",
      "data",
      "Data",
    ] as const;

    for (const key of nestedKeys) {
      const nested = record[key];
      if (nested && typeof nested === "object") {
        if (readFromRecord(nested as Record<string, unknown>)) {
          return true;
        }
      }
    }

    return false;
  };

  if (typeof payload !== "object") {
    return false;
  }

  return readFromRecord(payload as Record<string, unknown>);
};
